import { barFillStyle } from '@utils/barStyle.js'

interface Props {
  pctPago: number
  pctLiberado: number
  compact?: boolean
}

/**
 * Barra dupla: camada clara = serviço liberado (medido), camada sólida = pago.
 * Quando pago ultrapassa liberado, o excesso fica visível em tom de alerta.
 */
export function PagamentoBar({ pctPago, pctLiberado, compact = false }: Props) {
  const pago = Math.min(Math.max(pctPago, 0), 100)
  const liberado = Math.min(Math.max(pctLiberado, 0), 100)
  const adiantado = pago > liberado

  return (
    <div
      className={`cf3-pagbar${compact ? ' cf3-pagbar--compact' : ''}`}
      role='progressbar'
      aria-valuenow={pago}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={`${pago}% pago, ${liberado}% liberado`}
    >
      <div className='cf3-pagbar__liberado' style={barFillStyle(Math.max(liberado, pago))} />
      <div
        className={`cf3-pagbar__pago${adiantado ? ' cf3-pagbar__pago--adiantado' : ''}`}
        style={barFillStyle(pago)}
      />
    </div>
  )
}
